// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FUfM","col":"styles_col__2bcfy"};